import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IToggleRTMPlanReq, IToggleRTMPlanRes } from './index.type';

const useToggleRTMPlan = ({ RTMPlanId }: { RTMPlanId?: string }) => {
  const { loading: toggleRTMPlanLoading, makeApiCall } = useApi({
    // url: `/RTM/rtm-plan/deactivate/${RTMPlanId}`,
    url:`/rtm/plan/${RTMPlanId}`,
    method: 'PATCH',
  });

  const toggleRTMPlan = async (FormData: IToggleRTMPlanReq) => {
    const { response, error } = await makeApiCall<IToggleRTMPlanReq, IToggleRTMPlanRes>(FormData);

    if (response?.status === 'success') {
      toast.success('RTM Plan status changed successfully.');
      return response;
    }

    if (error) {
      toast.error('Something went wrong whiling changing RTM Plan status. Please try again later');
      return { status: 'fail' };
    }
  };

  return {
    toggleRTMPlanLoading,
    toggleRTMPlan,
  };
};

export default useToggleRTMPlan;
